import * as React from 'react';
import Tag from '../tag';
export default function PickerTag(props) {
    return <Tag color="blue" {...props}/>;
}
